import type { FC } from "react";
import { Icon } from "../UI/Icon";

interface ChevronLeftIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export const ChevronLeftIcon: FC<ChevronLeftIconProps> = (props) => (
  <Icon {...props} variant="filled">
    <path d="M11.8613 0C11.6908 0 11.528 0.0511833 11.3867 0.142578L11.2529 0.246094L11.251 0.249023L0.250977 11.249C0.0924368 11.4076 0.000976562 11.6228 0.000976562 11.8496C0.000976562 12.0764 0.0924368 12.2917 0.250977 12.4502L11.251 23.4502C11.4095 23.6087 11.6248 23.6992 11.8516 23.6992H11.8613C12.0882 23.6992 12.3034 23.6087 12.4619 23.4502C12.6205 23.2917 12.7109 23.0764 12.7109 22.8496C12.7109 22.6228 12.6205 22.4076 12.4619 22.249L2.09863 11.8848C2.09608 11.8764 2.09258 11.8667 2.09082 11.8564C2.08877 11.8445 2.09033 11.836 2.09082 11.8311L12.4619 1.4502C12.6205 1.29166 12.7109 1.07643 12.7109 0.849609C12.7109 0.622787 12.6205 0.407563 12.4619 0.249023C12.3034 0.0904839 12.0882 0 11.8613 0Z" />
  </Icon>
);
